export enum ClubCardType {
    cctDefault = 0,
    cctBarcode = 1,
    cctStripe = 4
}